<div class="handover">
  <div class="topbar">
    <div class="topbar__left">
      <dsy-content-switcher [contentList]="switchItems" [functionSetterData]="handleSwitch"> </dsy-content-switcher>
    </div>
    <div class="topbar__right">
      @if (showDeleteButtonSignal()) {
        <dsy-button icon-side="left" icon-name="check_circle_outline" [iconSize]="'1.16rem'" icon-library="material" variant="secondary" fill (click)="handleDeleteLogs()">
          Delete Requests
        </dsy-button>
      }
      @if (showCreateButtonSignal()) {
        <dsy-button [iconSide]="'left'" [iconName]="'download'" [iconLibrary]="'material'" [iconSize]="'1.16rem'" variant="link" color="neutral" (click)="exportCSV()">
          Export CSV
        </dsy-button>
        <dsy-button icon-side="left" icon-name="add" [iconSize]="'1.16rem'" icon-library="material" variant="primary" (click)="handleCreate()"> Create Handover Log </dsy-button>
      } @else if (showResolveButtonSignal()) {
        <dsy-button icon-side="left" icon-name="check_circle_outline" [iconSize]="'1.16rem'" icon-library="material" variant="primary" fill (click)="resolveLogs()">
          Resolve Activity
        </dsy-button>
      }
    </div>
  </div>
  <dr-ops-stream-ui-handover-filters [options]="filterOptionsSignal()" (filtersChange)="onFiltersChange($event)"> </dr-ops-stream-ui-handover-filters>
  <dr-ops-stream-ui-table-state [isLoading]="isLoadingSignal()" [hasData]="showTableSignal()" [totalItems]="filteredLogsSignal().length" emptyTitle="No handover logs found.">
    <dr-ops-stream-ui-handover-table
      [rows]="pagedLogsSignal()"
      [selectedOpsStreamType]="selectedOpsStreamTypeSignal()"
      (viewLog)="handleView($event)"
      (editLog)="handleEdit($event)"
    />
  </dr-ops-stream-ui-table-state>
</div>
